export default "__VITE_ASSET__Dx9k$_Am__"